import { Navigate, useLocation } from "react-router-dom";
import { useComplianceAuth } from "../context/ComplianceAuthContext";
import type { ReactNode } from "react";

export default function ComplianceProtectedRoute({
  children,
}: {
  children: ReactNode;
}) {
  const { isAuthenticated } = useComplianceAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/Compliance/logistics/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return <>{children}</>;
}
